(function() {
    window.track = function(data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    };
}());
